import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { DeliveryAreaService } from '../delivery-area.service';
import { DeliveryEngagementsService } from './delivery-engagements.service';
import { DeliveryEngagementsTab1Part } from './tabs/tab-1/delivery-engagements-tab-1.part';
import { DeliveryEngagementsTab2Part } from './tabs/tab-2/delivery-engagements-tab-2.part';
import { DeliveryEngagementsViewsPart } from './views/engagements-views.part';


@Component({
	selector: 'delivery-engagements-page',
	standalone: true,
	imports: [
		DeliveryEngagementsTab1Part,
		DeliveryEngagementsTab2Part,
		DeliveryEngagementsViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		TrimesterDroplistWidget,
		DroplistWidget,
		ToolbarWidget,
		PageTabsWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './delivery-engagements.page.html',
})
export class DeliveryEngagementsPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;
	public deliveryService = inject(DeliveryAreaService);

	constructor(public pageService: DeliveryEngagementsService) { }

	async ngOnInit() {
		await this.deliveryService.loadDeliveryData();
	}

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}
}